export const BankList = [
  'Abhyudaya Co-Operative Bank Ltd',
  'Allahabad Bank',
  'Andhra Bank',
  'AU Small Finance Bank',
  'Axis Bank',
  'Bandhan Bank',
  'Bank of Bahrain and Kuwait',
  'Bank of Baroda',
  'Bank of India',
  'Bank of Maharashtra',
  'Canara Bank',
  'Catholic Syrian Bank',
  'Central Bank of India',
  'Citibank',
  'City Union Bank',
  'Corporation Bank',
  'DBS Bank',
  'DCB Bank',
  'Dhanlaxmi Bank',
  'Equitas Small Finance Bank',
  'Federal Bank',
  'GP Parsik Bank',
  'HDFC Bank',
  'ICICI Bank',
  'IDBI Bank',
  'IDFC FIRST Bank',
  'Indiabulls',
  'Indian Bank',
  'Indian Overseas Bank',
  'Indusind Bank',
  'ING Vysya Bank',
  'Jammu and Kashmir Bank',
  'Karnataka Bank Ltd',
  'Karur Vysya Bank',
  'Kotak Mahindra Bank',
  'Lakshmi Vilas Bank',
  'Nainital Bank',
  'Oriental Bank of Commerce',
  'Paytm Payments Bank',
  'Punjab & Sind Bank',
  'Punjab National Bank',
  'RBL Bank',
  'Shamrao Vitthal Co-operative Bank',
  'South Indian Bank',
  'Standard Chartered',
  'State Bank of Bikaner & Jaipur',
  'State Bank of Hyderabad',
  'State Bank of India',
  'State Bank of Mysore',
  'State Bank of Patiala',
  'State Bank of Travancore',
  'Syndicate Bank',
  'Tamilnad Mercantile Bank Ltd.',
  'UCO Bank',
  'Ujjivan Small Finance Bank',
  'Union Bank of India',
  'United Bank of India',
  'Vijaya Bank',
  'Yes Bank Ltd',
  'HDFC BANK LTD'
];
